class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll("details").forEach((el) => {
      el.addEventListener("toggle", () => {
        if (el.open) {
          this.querySelectorAll("details").forEach((d) => {
            if (d !== el) d.removeAttribute("open");
          });
        }
      });
    });
  }
}
customElements.define("product-tabs", ProductTabs);
class ProductTabsDesktop extends HTMLElement {
  connectedCallback() {
    const buttons = this.querySelectorAll(".tab-btn");
    const tabs = this.querySelectorAll(".tab-content");
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.dataset.tab;
        buttons.forEach((b) => b.classList.remove("active", "border-gray-900", "text-gray-900"));
        tabs.forEach((t) => t.classList.add("hidden"));
        btn.classList.add("active", "border-gray-900", "text-gray-900");
        this.querySelector(`#${id}`).classList.remove("hidden");
      });
    });
  }
}
customElements.define("product-tabs-desktop", ProductTabsDesktop);
